module.exports = __webpack_public_path__ + "img/top-bg.5a4cab0d.png";